export default __webpack_public_path__ + "static/media/21_tag_kitchenware-tableware.e25141ae.svg";